import { Theme } from "@mui/material";

/**
 * Enum representing the different order statuses
 */
export enum OrderStatus {
    PENDING = 1,
    PROCESSING = 2,
    SHIPPED = 3,
    CANCELLED = 4,
    REFUND_REQUESTED = 5,
    REFUND_APPROVED = 6,
    REFUNDED = 7,
    REFUND_REJECTED = 8,
}

/**
 * Get the display text for an order status
 * @param status - The status code
 * @param compact - Whether to return a compact version of the status text
 * @returns The display text for the status
 */
export const getOrderStatusText = (status: OrderStatus, compact = false): string => {
    switch (status) {
        case OrderStatus.PENDING:
            return compact ? "Pending" : "Pending";
        case OrderStatus.PROCESSING:
            return compact ? "Processing" : "Processing";
        case OrderStatus.SHIPPED:
            return compact ? "Shipped" : "Out for Delivery";
        case OrderStatus.CANCELLED:
            return compact ? "Cancelled" : "Cancelled";
        case OrderStatus.REFUND_REQUESTED:
            return compact ? "Refund Req." : "Refund Requested";
        case OrderStatus.REFUND_APPROVED:
            return compact ? "Refund Appr." : "Refund Approved";
        case OrderStatus.REFUNDED:
            return compact ? "Refunded" : "Refunded";
        case OrderStatus.REFUND_REJECTED:
            return compact ? "Refund Rej." : "Refund Rejected";
        default:
            return "Unknown";
    }
};

/**
 * Get the color for an order status
 * @param status - The status code
 * @param theme - The theme object from MUI
 * @returns The color for the status
 */
export const getOrderStatusColor = (status: OrderStatus, theme: Theme ): string => {
    switch (status) {
        case OrderStatus.PENDING:
            return theme.palette.grey[500];
        case OrderStatus.PROCESSING:
            return "orange";
        case OrderStatus.SHIPPED:
            return "blue";
        case OrderStatus.CANCELLED:
            return theme.palette.grey[600];
        case OrderStatus.REFUND_REQUESTED:
            return "#ff5722";
        case OrderStatus.REFUND_APPROVED:
            return "#e91e63";
        case OrderStatus.REFUNDED:
            return "#673ab7";
        case OrderStatus.REFUND_REJECTED:
            return "#f44336";
        default:
            return theme.palette.grey[500];
    }
}; 